import React from 'react';
import services from '../../../services';
import TitleBar from '../../../components/common/title_bar';
import { withRouter } from 'react-router-dom';
import SearchFilter from '../../../components/filters/SearchFilter';
import { toast } from 'react-toastify';
import Lang from '../../../lang'
import RevenueModalForm from '../../../components/VidimaModule/Modal/CommonSideModalForm';
import $ from 'jquery'
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import RecentInvoiceGenPopUp from './RecentInvoiceGenPopUp'
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import RevenueEntityAction from '../../../components/common/RevenueEntityAction';
import TransferirModal from './TransferirModal'
import RevenueTables from './RevenueTables';
import { Button } from '@progress/kendo-react-buttons'
var moment = require('moment')
const dateFormat = "YYYY-MM-DD";

const servicesMenuArray = [
    { "main": "Tx. Aguardente", name: "Taxas referentes à comercialização de aguardente" },
    { "main": "Tx. Vinhos", name: "Taxas referentes à comercialização de vinhos no mercado nacional, estrangeiro e vinho modificado" },
    { "main": "Selos e Cápsulas", name: "Compras de Selos e/ou Cápsulas" },
    { "main": "req. serviços", name: "Requisições de serviço" },
    { "main": "fiscalização", name: "Custos de fiscalização" },
    { "main": "medidas de intervenção", name: "Taxas referentes às Medidas de Intervenção" },
    { "main": "artigos diversos", name: "Artigos diversos", api: "" },
    { "main": "juros de mora", name: "Juros de Mora" },
    { "main": "observações", name: "Observações diversas" },
]

let defaultRequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};
class ReceitasEmCobranca extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filter: this.props.linkData.filters,
            popUpForm: '',
            popUpForm2: null,
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            },
            billing_address: null,
            applyedfilter: {
              //  entity_id: this.props.parsed.entity_id
            },
            checkedInvoice: [],
            general_balance_row: "",
            date:new Date(),
            recentGenInvoicePopUp:''
        }
    }

   /* Esta é a primeira etapa após o construxctor para carregar este componente  */

 componentDidMount() {
        this.createState();
        $(window).scrollTop(0);
        this.getCurrentGeneralAccount();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            $(window).scrollTop(0);
            this.createState();
        }
    }

    /* Para criar o estado básico da página no carregamento */

    createState = () => {
        this.setState({
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            },
            applyedfilter: {
                entity_id: null
            },
            filters: this.props.linkData.filters
        });

        if (this.props.parsed.entity_id) {
            console.log("cenasbb" ,this.state)
            let applyedfilter = {...this.state.applyedfilter};
            applyedfilter.entity_id = this.props.parsed.entity_id
            this.setState({
                applyedfilter
            },()=>this.getEntityDetails(this.props.parsed.entity_id));
        }
        if(this.props.parsed.invoice_id){
            let applyedfilter = {...this.state.applyedfilter};
            applyedfilter.invoice_id = ""+this.props.parsed.invoice_id
            this.setState({
                applyedfilter
            });
        }
    }

    
    /**
     * obter conta geral
     */
    getCurrentGeneralAccount = async () => {
        if (this.props.tab === "general_account") {
            let link = "Revenue/GeneralAccount/GetLastDetails"
            let res = await services.apiCall.requestApi(link, {}, "get");
            if (res) {
                this.setState({
                    general_balance_row: res,
                    date:new Date()
                });
            } else {
                this.setState({
                    general_balance_row: {
                        balance: 0,
                        date:new Date()
                    }
                });
            }
        }
    }

    /*Para obter detalhes de uma única entidade usando api */

    getEntityDetails = async (entity_id) => {
        let Request = {};
        console.log("Entityfunction ", Request)
        this.setState({
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            }
        });
        if(!entity_id)
            return 
        Request.entityId = parseInt(entity_id);
        let link = "/Revenue/getEntityDetail"
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState({
                entity_details: res
            });
        }
    }


    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {
        console.log("cenas" , data)
        // this.setState({
        //     filterData: data
        // }, () => this.createTabel())
    }

    transferirModalOpen = () => {
        let popup = (
            <TransferirModal date={new Date()} general_balance={this.state.general_balance_row.balance} closePopup={() => this.closePopup()} />
        )

        this.setState({transferirPopUpForm : popup})
    }

    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (customfilters) => {
        let applyedfilter = { ...customfilters.filterCheckbox, ...customfilters.filters }
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem('Local');
        console.log("filter", applyedfilter);
        this.setState({
            applyedfilter,
            date:new Date()
        }, () => this.getEntityDetails(applyedfilter.entity_id)
        );
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        console.log(action, row);
        let popUpForm = null;
        let newUrl=null;
        let invoice_id="";
        if(row.invoice_id){
            invoice_id=row.invoice_id;
        }else{
            invoice_id=row.id;
        }
        let topBarMenu = this.props.topBarMenuOption

        if (action === 'mover para a fatura') {
            let paramoption = {
                url : "revenue_faturas",
                name : "Emitir Faturas",
                tableName : "FaturasEmitir",
                entity_id : row.entity_id,
                invoice_id : invoice_id
            }
            newUrl = '/revenue_faturas'
            // newUrl = '/revenue_faturas?u=revenue_faturas&p=Emitir%20Faturas&t=FaturasEmitir' + "&entity_id=" + row.entity_id+"&invoice_id=" +invoice_id;
            this.props.history.push({pathname:newUrl,state:{topBarMenu : topBarMenu ,paramoption : paramoption }})
            return;
            // window.history.pushState({}, null, newUrl);
        } else if (action === "ir para a fatura") {
            let paramoption = {
                url : "revenue_receitas",
                name : "Recibos de Adiantamento",
                tableName : "TesourariaRecabo",
                entity_id : row.entity_id,
                invoice_id : invoice_id
            }
            newUrl = '/revenue_receitas'
            // newUrl = '/revenue_receitas?u=revenue_receitas&p=Recibos%20de%20Adiantamento&t=TesourariaRecabo' + "&entity_id=" + row.entity_id +"&invoice_id=" +invoice_id;
            this.props.history.push({pathname:newUrl,state:{topBarMenu : topBarMenu ,paramoption : paramoption}})
            return;
            // window.history.pushState({}, null, newUrl);
        } else if (action === 'RedirectTwo') {
            let paramoption = {
                name: 'Gerar Documento',
                url: 'revenue_criacao',
                tableName: "Tesouraria",
                entity_id : row.entity_id,
                invoice_id : invoice_id
            }
            newUrl = '/revenue_receitas'
            // newUrl = '/revenue_receitas?u=revenue_receitas&p=Consulta%20de%20Conta%20corrente&t=TesourariaContacorrente' + "&entity_id=" + row.entity_id+"&invoice_id=" +invoice_id;
            this.props.history.push({pathname:newUrl,state:{topBarMenu : topBarMenu ,paramoption : paramoption}})
            return;
            // window.history.pushState({}, null, newUrl);
        } else if (action === 'Mover de geral para avançado') {
            let paramoption = {
                name: 'Recibos de Adiantamento',
                url: 'revenue_receitas',
                tableName: "TesourariaRecabo",
                entity_id : row.entity_id,
                invoice_id : invoice_id
            }
            newUrl= '/revenue_receitas'
            // newUrl= '/revenue_receitas?u=revenue_receitas&p=Recibos%20de%20Adiantamento&t=TesourariaRecabo' + "&entity_id=" + row.entity_id+"&invoice_id=" +invoice_id;
            this.props.history.push({pathname:newUrl,state:{topBarMenu : topBarMenu ,paramoption : paramoption}})
            return;
            // window.history.pushState({}, null, newUrl);
        }
        else if (action === 'RedirectTwo') {
            // let paramoption = {
            //     name: 'Recibos de Adiantamento',
            //     url: 'revenue_receitas',
            //     tableName: "TesourariaRecabo",
            //     entity_id : row.entity_id,
            //     invoice_id : invoice_id
            // }
            newUrl = '/revenue_page?name=faturas&type=' + row.trans_msg + "&id=" + row.id + "&entity_id=" + row.busEntidadeDetail.nifap+"&invoice_id=" +invoice_id;
            this.props.history.push({pathname:newUrl,state:{}})
            return;
            // window.history.pushState({}, null, newUrl);
        }
        else if (action == 'Edit') {
            this.props.history.push({
                pathname: "/entity_rule_form",
                state: { entidade_id: row.codEntidade }
            })
            return;
        } else if (action === 'detailPopUp' || action === 'detailPopUpTwo') {
            popUpForm = this.openDetailPopUpForm(row, action);
        }
        else if (action === "checkedInvoice") {
            let checkedInvoice = Object.values(row);
            // if (checkedInvoice.length) {
                this.GetInvoiceLink(checkedInvoice);
            // }
        } else if (action === "Add_Amount") {
            this.addamountFrom(action, row)
        } else
            popUpForm = (
                <RevenueModalForm
                    tab={action}
                    data={row} 
                    date={new Date()}
                    ActionPerform={(action, row) => this.ActionPerform(action, row)}
                    closePopup={() => this.closePopup()} />
            )
        if (popUpForm) {
            this.setState({ popUpForm })
        }
    }

    /*  Para abrir o formulário de adição de valor para uma entidade selecionada  */

    addamountFrom = async (action, row) => {
        let Request = {}
        Request.entityId = parseInt(row.busEntidade.nifap);
        let link = "/Revenue/getEntityDetail"
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState({
                entity_details: res
            }, () => this.updateNavDropdown(action, row));
        }
    }

    /*  Para abrir o pop-up com base na ação selecionada  */

    updateNavDropdown = (action,row, pageName = "faturasRecibos", forfutureInvoice = 0) => {
        const parsed = this.props.parsed;
        let popUpForm = (
            <RightPopModalForm
                closePopup={()=>this.closePopup()}
                date={new Date()}
                tab={action}
                userPage={this.props.userPage}
                pageName={pageName}
                forfutureInvoice={forfutureInvoice}
                optionMenuArray={servicesMenuArray}
                parsed={parsed}
                updateServiceslist={(list) => this.updateServiceslist(list)}
                completeData={null}
                billing_address={null}
                getCurrentGeneralAccount={() => this.getCurrentGeneralAccount()}
                Invoice={row}
                entity_details={this.state.entity_details}
            />
        )
        this.setState({
            popUpForm
        })
    }

    GetInvoiceLink = async (checkedInvoice) => {
        let link = "/Revenue/GetInvoiceLink";
        if (checkedInvoice.length == 0) {
            return
        }
        let request = { invoice_id: checkedInvoice }
        let res = await services.apiCall.requestApi(link, request);
        if (res) {
            toast.success("Documentos criados com sucesso");
            this.openRecentGeneratedInvoicePopUp(checkedInvoice);
            this.setState({ 
                checkedInvoice:[],
                date:new Date()
            });
        }
    }

    openRecentGeneratedInvoicePopUp = (checkedInvoice) => {
        let recentGenInvoicePopUp = (
            <RecentInvoiceGenPopUp tableName="RecentGenInvoice" date={new Date()} invoiceIDs={checkedInvoice} />
        )

        this.setState({recentGenInvoicePopUp})
        $("#recentInvoiceModalButton").trigger("click");
    }


    /*  Para abrir pop-up para detalhes */

    openDetailPopUpForm = (row, action) => {

        let popUpForm = '';

        if (this.props.linkData.popUpTwoTabName && action === 'detailPopUpTwo') {
            popUpForm = (
                <RevenueModalForm tab={this.props.linkData.popUpTwoTabName} data={row} date={new Date()} closePopup={() => this.closePopup()} />
            )
        } else if (row.document_type == 'Credit') {
            popUpForm = (
                <RevenueModalForm
                    tab={"Credit Details"}
                    data={row}
                    date={new Date()}
                    closePopup={() => this.closePopup()}
                />
            )
        }
        else {
            popUpForm = (
                <RevenueModalForm
                    tab={this.props.linkData.popUpTabName}
                    // tab={action}
                    data={row}
                    date={new Date()}
                    popUpForm2={this.state.popUpForm2}
                    updatePopUpFormDouble={(action, row) => this.updatePopUpFormDouble(action, row)}
                    closePopup={() => this.closePopup()}
                />
            )
        }
        this.setState({
            popUpForm
        })
    }


    /*  Para abrir pop-up em um pop-up */

    updatePopUpFormDouble = (popUpForm2) => {
        this.setState({
            popUpForm2
        })
        $("#firstPopup").trigger("click");
        $("#secondPopup").trigger("click");
    }

    /*  Para fechar pop-up  */

    closePopup = () => {
        this.getCurrentGeneralAccount();
        this.setState({
            date:new Date()
        });
        if(this.state.entity_details.busEntidade && this.state.entity_details.busEntidade.nifap){
            this.getEntityDetails(this.state.entity_details.busEntidade.nifap)

        }
        $(".left-popup").trigger('click');
    }

    updateServiceslist = (list) => {
        this.props.updateServiceslist(list)
    }

/*  Para renderizar o conteúdo html da página   */

render() {
    console.log("Tablename",this.props.linkData.tableName);
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        path={this.props.linkData.TitleBarpath}
                        title={this.props.linkData.TitleBartitle}
                        logo={this.props.linkData.TitleBarlogo}
                        prevPageName={this.props.linkData.prevPageName}
                        prevPageLink={this.props.linkData.prevPageLink}
                        linkData={this.props.linkData}
                        noOption={true}
                        changeOption={(mainIndex, subIndex) => this.props.changeOption(mainIndex, subIndex)} optionMenuArray={this.props.optionMenuArray} />
                    {
                        this.props.linkData.filters && Object.keys(this.props.linkData.filters).length > 0 &&
                        // <SearchFilter
                        //     optionText="Pesquisa por NIF ou nome"
                        //     installationNumber={true}
                        //     date={this.state.date}
                        //     filters={this.props.linkData.filters}
                        //     moduleType="Receita"
                        //     clickLimparFilter={this.state.clickLimparFilter}
                        //     data={this.state.data}
                        //     handleFilter={(data) => this.handleFilter(data)}
                        //     getFilter={(data) => this.getFilters(data)}
                        // />
                        // <SearchFilter typeFilter={"nif"}
                        //     filters={this.props.linkData.filters}
                        //     handleFilter={(data) => this.handleFilter(data)}
                        //     getFilter={(data) => this.getFilters(data)}
                        //     data={this.state.data} 
                        // />
                        <SearchFilter 
                        optionText="Pesquisa por NIF ou Designação"
                        installationNumber={ true }
                        filters={ this.props.linkData.filters }
                        //-clickLimparFilter={this.state.clickLimparFilter}
                        searchplaceholder={ "Pesquisa por Nº de Instalação IVDP ou Designação" }
                        handleFilter={ (data) => this.handleFilter(data) }
                        getFilter={ (data) => this.getFilters(data) }
                        data={ this.state.data }
                        moduleType="Receita"
                        
                    />
                    }
                   
                    {
                        <RevenueEntityAction
                            entity_details={this.state.entity_details}
                            closePopup={() => this.closePopup()}
                            Actionlist={{ valor: true, Movimento: false, recibo: false }}
                            date={new Date()}
                            parsed={this.props.parsed}
                            getEntityDetails={(id) => this.getEntityDetails(id)}
                            linkData={this.props.linkData}
                            pageName={this.props.tab}
                            general_balance={this.state.general_balance_row}
                        />
                    }
                     {
                        this.state.general_balance_row && this.props.linkData && this.props.linkData.tableName === "general_account" && this.props.tab === "general_account" &&
                        <div className="tab-section col-md-12">
                            <div className="innerBox active cursor-pointer">
                                <div className="display-content">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <p><strong>Balanço Geral Atual:</strong></p>{services.money.format(this.state.general_balance_row.balance)}
                                        </div>
                                        <div className="col-md-2">
                                            <Button data-toggle="modal" data-target="#vindima-modal" primary={true} onClick={() => this.updateNavDropdown('Add_General_Amount', "general_account")} className="btn-ivdp-primary mr-2  k-primary">Adicionar Conta Geral</Button>
                                        </div>
                                        <div className="col-md-2">
                                            <Button data-toggle="modal" data-target="#transferir-valor-modal" primary={true} onClick={() => this.transferirModalOpen()} className="btn-ivdp-primary k-primary">Transferir Valor</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        <RevenueTables
                            date={this.state.date}
                            tableName={this.props.linkData.tableName}
                            applyedfilter={this.state.applyedfilter}
                            ActionPerform={(action, row) => this.ActionPerform(action, row)}
                        />
                    }
                </div>
                <div className="modal left-popup" id="vindima-modal">
                    <div className="modal-dialog modal-lg">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>
                <input type='hidden' data-toggle="modal" data-target="#vindima-modal" id="firstPopup" />
                <input type='hidden' data-toggle="modal" data-target="#leftdetailpopup" id="secondPopup" />
                <div className="modal left-popup left-popup2" id="leftdetailpopup">
                    <div className="modal-dialog modal-sm">
                        {
                            this.state.popUpForm2
                        }
                    </div>
                </div>
                {
                    <div>
                        <button className="hidden" data-toggle="modal" data-target="#revenuEntityactionpopup" id="revenuEntityactionpopupbutton"></button>
                        <div className="modal left-popup" id="revenuEntityactionpopup">
                            <div className="modal-dialog modal-lg">
                                {
                                    this.state.popUpForm
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    <div>
                        <div className="modal left-popup" id="transferir-valor-modal">
                            <div className="modal-dialog modal-lg">
                                {
                                    this.state.transferirPopUpForm
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    <div> 
                        <button className="hidden" data-toggle="modal" data-target="#recent-invoice-modal" id="recentInvoiceModalButton"></button>
                        <div className="modal left-popup" id="recent-invoice-modal">
                            <div className="modal-dialog modal-lg">
                                {
                                    this.state.recentGenInvoicePopUp
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}


export default withRouter(ReceitasEmCobranca);